import React from 'react';
import PropTypes from 'prop-types';

export const GraphGoalLabel = ( props ) => {

    const { y, data, label } = props;

    const getY = ( y ) => {
		if ( data[ 0 ].y > 0 ) {
			return y + 6;
		} else {
			return y - 14;
		}
    };

    return (
        <text dx={ 115 } dy={ getY( y ) } className="goal-label" style={ { fill: '#996300', fontWeight: 'bold' } }>{label}</text>
    );
};

GraphGoalLabel.propTypes = {
    y: PropTypes.number,
    label: PropTypes.string,
    data: PropTypes.array
};

export default GraphGoalLabel;
